// VueJS
import Vue from 'vue'

import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);

// Ant Design Vue
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.use(Antd);

// Photoswipe Gallery
import Photoswipe from 'vue-pswipe'

Vue.use(Photoswipe)

Vue.prototype.$profilekoas = [];

// Template Layouts
import DefaultLayout from './layouts/Default.vue'
import DashboardLayout from './layouts/Dashboard.vue'
import DashboardRTLLayout from './layouts/DashboardRTL.vue'

// Adding template layouts to the vue components.
Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);
Vue.component("layout-dashboard-rtl", DashboardRTLLayout);

// Excel
import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);

// Firebase

import {initializeApp} from "firebase/app";
import {getMessaging, getToken} from "firebase/messaging";

if (window.use_notif) {
    const f = async () => {
        const firebaseConfig = {
            apiKey: "AIzaSyDfHAxmgPZeXaAN4fE1v49KJHT6uYMyjh8",
            authDomain: "simkoas.firebaseapp.com",
            projectId: "simkoas",
            storageBucket: "simkoas.appspot.com",
            messagingSenderId: "743384407956",
            appId: "1:743384407956:web:0b486a84b2857d08177981"
        };

        // Initialize Firebase
        const firebaseApp = initializeApp(firebaseConfig)
        window.fcm = getMessaging(firebaseApp)

        getToken(fcm, {
            vapidKey: 'BLER2CqD2_FuHkKVXG5_1o8LXbbH8Xxe7Svo1VQ0xaLzGvvxT7HLdTOescU66teXmFuh2-fEO4VYIHRdG6Jo8bY',
            serviceWorkerRegistration: await navigator.serviceWorker.register('/siakri/firebase-messaging-sws.js')
            // serviceWorkerRegistration: await navigator.serviceWorker.register('/firebase-messaging-sws.js')
        })
            .then(token => {
                LocalRepository.setFirebaseToken(token)
                console.log("Success get firebase token " + token)
            })
            .catch(e => {
                console.log(`Error firebase ${e}`)
            })
    }

    f()
}

// Main application view
import App from './App.vue'

// Vue Router
import router from './router'

// App Styling
import './scss/app.scss';
import store from "./store";
import LocalRepository from "./repository/LocalRepository";
import {apiState} from "./repository/api/ApiState";

Vue.prototype.$loading = false;
Vue.prototype.$rsprofile = {
    address: "",
    aplicares_base_url: "",
    bookingdu_base_url: "",
    bpjs_base_url: "",
    bpjs_cons_id: "",
    bpjs_faskes_code: "",
    bpjs_secret_key: "",
    bpjs_user_key: "",
    created_at: "",
    description: "",
    director: "",
    doctor_schedule_status: "",
    email: "",
    fleg: "",
    id: "",
    id_kabuapaten: "",
    id_kabupaten: "",
    id_kelurahan: "",
    id_provinsi: "",
    id_user: "",
    kemenkes_faskes_code: "",
    key_inacbg: "",
    lat: "",
    lng: "",
    name: "",
    phone: "",
    photo_path: "",
    photo_region: "",
    post_code: "",
    rekmed_digit: "",
    rekmed_separator: "",
    status: "",
    type: "",
    updated_at: "",
    url_inacbg: "",
    warehouse_default_code: "",
    warehouse_default_search_code: "",
    web: "",
};

Vue.config.productionTip = false

// if (Vue.swal) {
//     const $swal = Vue.swal
//
//     Vue.swal = (options) => {
//         if (apiState.needToRefreshPage) {
//             apiState.needToRefreshPage = false
//
//             if (!$swal.isVisible()) {
//                 $swal({
//                     ...options,
//                     didClose: () => {
//                         console.log("OnCLose")
//                         location.reload()
//                     }
//                 })
//             }
//         } else {
//             $swal(options)
//         }
//     }
// }
//
// if (Vue.prototype.$swal) {
//     const $swal = Vue.prototype.$swal
//
//     Vue.prototype.$swal = (options) => {
//         if (apiState.needToRefreshPage) {
//             apiState.needToRefreshPage = false
//
//             if (!$swal.isVisible()) {
//                 $swal({
//                     ...options,
//                     didClose: () => {
//                         console.log("OnCLose")
//                         location.reload()
//                     }
//                 })
//             }
//         } else {
//             $swal(options)
//         }
//     }
// }

// Initialize Vue
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')